import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { filterBoolean } from '@recruitee/common';

import { RemoteTemplate } from '../../../types';
import { RemoteTemplateActions, RemoteTemplateSelectors } from './remote-template.store';

@Injectable({ providedIn: 'root' })
export class RemoteTemplateStoreService {
  constructor(private store: Store) {}

  public getRemoteTemplates(integrationKind: string): Observable<RemoteTemplate[]> {
    return this.store
      .select(RemoteTemplateSelectors.entities({ scope: integrationKind }))
      .pipe(filterBoolean);
  }

  public getRemoteTemplatesLoading(integrationKind: string): Observable<boolean> {
    return this.store.select(
      RemoteTemplateSelectors.isPending({
        scope: integrationKind.toString(),
      }),
    );
  }

  public getRemoteTemplatesFailed(integrationKind: string): Observable<boolean> {
    return this.store.select(
      RemoteTemplateSelectors.isFailed({
        scope: integrationKind.toString(),
      }),
    );
  }

  public fetchRemoteTemplates(integrationKind: string): void {
    this.store.dispatch(
      RemoteTemplateActions.fetchCollection({
        payload: { scope: integrationKind.toString() },
      }),
    );
  }
}
